// LabelDisplay.tsx
import React, { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import { labelStore } from './LableStore';

const LabelDisplay = () => {
  const [label, setLabel] = useState(labelStore.getLabel());

  useEffect(() => {
    const unsubscribe = labelStore.subscribe(setLabel);
    return () => unsubscribe();
  }, []);

  return <Typography  variant="h6" fontWeight={700} color="#098963" >{label}</Typography>;
};

export default LabelDisplay;
